




































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class BankAccountView extends Vue {
  public items: Common.BankAccount[] = new Array(0);
  public params: Common.BankAccountQuery = new Common.BankAccountQuery();
  public importQuery = new Common.BankAccountImportQuery('銀行口座');
  public exportQuery = new Common.BankAccountExportQuery('銀行口座', this.params);
  public tenantSettings: Common.TenantSettings = null;
  public hasLicenseCurrency: boolean = false;
  public hasLicenseTrade: boolean = false;
  public tabVisibles: Array<boolean> = [true,true, false, true, true];
  @Prop() public auditNo:string;

  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([], 0,'grid');
  public taxTypes = Common.TaxTypes;

  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'code', text: 'コード' },
    { value: 'name', text: '名称' },
    { value: 'segment', text: '部門' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];

  public created() {
    //テナント設定をロードする
    this.tenantSettings = this.$api.tenantSettings;
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    this.hasLicenseTrade = this.$api.hasLicense(Common.licenseFlags.import) || this.$api.hasLicense(Common.licenseFlags.export);

    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 100),
      new Common.GridItemConfiguration('ワークフロー', 180),      
      new Common.GridItemConfiguration('コード', 120),
      new Common.GridItemConfiguration('名称', 150),      
      new Common.GridItemConfiguration('銀行名称', 150),
      new Common.GridItemConfiguration('支店名称', 150),
      new Common.GridItemConfiguration('通貨', 100,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('口座種別', 100),
      new Common.GridItemConfiguration('口座番号', 150),
      new Common.GridItemConfiguration('口座名義', 150),
      new Common.GridItemConfiguration('勘定科目', 150),
      new Common.GridItemConfiguration('補助科目コード(BS)', 150),
      new Common.GridItemConfiguration('補助科目コード(PL)', 150),      
      new Common.GridItemConfiguration('部門', 150),      
      new Common.GridItemConfiguration('手数料税区分', 150),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150)
    );    
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.importQuery.hasLicenseTrade = this.hasLicenseTrade;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseTrade = this.hasLicenseTrade;

    this.$set(this.tabVisibles, 2, this.hasLicenseTrade); // 請求・支払設定タブ

    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
  }

  public async onCreate(obj: Common.BankAccount) {
    // 販売管理ではシステム通貨固定
    obj.currencyCode = this.tenantSettings.currencyCode;
    
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.BankAccount):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }
}
